import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#070A28",
      d: "M.8 6.6A4.77 4.77 0 0 1 2.73 5.075a2.813 2.813 0 1 1 3.793 0c.552.238 1.054.58 1.478 1.006A4.7 4.7 0 0 1 9.48 5.075a2.813 2.813 0 1 1 3.793 0c.765.33 1.43.856 1.928 1.524a.56.56 0 0 1-.31.884.56.56 0 0 1-.59-.208 3.658 3.658 0 0 0-5.85 0l-.003.004-.037.042-.012.014-.05.044-.01.008-.02.013-.021.015-.035.02-.018.01a.6.6 0 0 1-.114.04l-.017.003-.041.007-.023.002-.035.002H7.99a1 1 0 0 1-.072-.006q-.01 0-.02-.003l-.059-.014-.02-.006a.6.6 0 0 1-.152-.08l-.005-.003-.023-.02-.014-.01-.033-.033-.006-.006a1 1 0 0 1-.043-.052 3.656 3.656 0 0 0-5.843.01.563.563 0 0 1-.9-.676m12.472 5.788a2.813 2.813 0 1 0-3.793 0A4.7 4.7 0 0 0 8 13.392a4.7 4.7 0 0 0-1.478-1.006 2.813 2.813 0 1 0-3.793 0c-.765.331-1.43.857-1.929 1.525a.563.563 0 0 0 .45.9h13.5a.562.562 0 0 0 .45-.9 4.77 4.77 0 0 0-1.928-1.525"
    }, null, -1)
  ])))
}
export default { render: render }